export const InitiativeJiraIssuesName = 'initiativeJiraIssues';
